export default function (value) {
  /*eslint-disable */
  return (
    value == undefined ||
    value == null ||
    value.length == 0 ||
    (Object.keys(value).length == 0 && value.constructor == Object)
  )
}
